<template>
  <div class="glide">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides">
        <li class="glide__slide">
          <img class="fit"
               src="img/image/mockup_3-2.png"
               height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/brand/mockup_2.png"
               height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/brand/mockup_3.png"
               height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/brand/mockup_4.png"
               height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/brand/mockup_5.png"
               height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/image/mockup_3-1.png"
               height="600" width="450" rel="nofollow">
        </li>
      </ul>
    </div>
    <div class="glide__arrows" data-glide-el="controls" style="min-width: 200px;">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <i class="ni ni-bold-left text-default"></i></button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        <i class="ni ni-bold-right text-default"></i></button>
    </div>
  </div>
</template>

<script>
import Glide, {Controls, Breakpoints} from '@glidejs/glide'

export default {
  name: "Glide",
  mounted() {
    new Glide('.glide', {
      type: 'carousel',
      startAt: 0,
      perView: 5,
      focusAt: 'center',
      autoplay: 5000,
      breakpoints: {
        1300: {
          perView: 4
        },
        1100: {
          perView: 3
        },
        800: {
          perView: 2
        },
        520: {
          perView: 1
        },
      },
    },).mount({});
  },
}
</script>

<style lang="scss" scoped>
.fit {
  object-fit: contain;
}

@media (max-width: 1600px) {
  .glide__arrow--left {
    left: 45%;
  }
  .glide__arrow--right {
    right: 45%;
  }
}

@media (max-width: 1100px) {
  .glide__arrow--left {
    left: 42%;
  }
  .glide__arrow--right {
    right: 42%;
  }
}

@media (max-width: 700px) {
  .glide__arrow--left {
    left: 39%;
  }
  .glide__arrow--right {
    right: 39%;
  }
}

@media (max-width: 500px) {
  .glide__arrow--left {
    left: 32%;
  }
  .glide__arrow--right {
    right: 32%;
  }
}
</style>
